import { render, staticRenderFns, recyclableRender, components } from "./my_collect.vue?vue&type=template&id=7b55a8f8&"
var renderjs
import script from "./my_collect.vue?vue&type=script&lang=js&"
export * from "./my_collect.vue?vue&type=script&lang=js&"
import style0 from "./my_collect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my_collect/my_collect.vue"
export default component.exports